<template>
    <section class="liste-modeles-analyse main-section">
        <div class="row">
            <div class="col-md-12">
                <div class="row mb-4">
                    <div class="col-lg-12">
                        <div class="body-header">
                            <div class="h-left animate animate-fadeInLeft">
                                <h1 class="p-title">
                                    <span class="text-primary">Paramètres</span> | Modèles d’analyse
                                </h1>
                            </div>
                            <div class="h-right animate animate-fadeInRight">
                                <div class="w-250p d-inline-block mr-2">
                                    <multiselect :show-labels="false" label="nom" :options="analyses"
                                        placeholder="Sélectionner l'analyse" v-model="selectedAnalyse" :allow-empty="true"
                                        track-by="id">
                                        <template slot="singleLabel" slot-scope="{ option }">{{ option.nom }}</template>
                                        <span slot="noResult">Aucun élément </span>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <div class="card is-hidden shw animate animate-fadeIn">
                            <div class="card-body">
                                <div class="basic-flex mb-2">
                                    <h3 class="c-title mb-3">Liste des modèles d’analyses</h3>
                                    <button class="btn btn-primary btn-radius"
                                        @click="$router.push({ name: 'creerModifierModeleAnalyse', params: { action: 'creer' } })">
                                        <i class="ic-plus h-13p"></i> Ajouter un modèle
                                    </button>
                                </div>

                                <b-row v-if="modelesAnalyses.length > 0">
                                    <div class="ml-0 col-lg-12 mb-2 pdlr-x">
                                        <input v-model="searchText" type="search"
                                            class="input-secondary-light border-radius-none"
                                            placeholder="Rechercher un modèle" autocomplete="off" />
                                    </div>
                                </b-row>

                                <div class="t-all-left" v-if="!model_is_loading && !model_is_empty">
                                    <b-table 
                                        hover outlined 
                                        :items="modelesAnalyses"
                                        :filter="searchText" 
                                        :current-page="currentPage" 
                                        :per-page="perPage" 
                                        responsive="sm"
                                        :fields="tableColumnNames"
                                    >
                                        <template #cell="data">
                                            <div class="text-justify">{{ data.value.value }}</div>
                                        </template>

                                        <template #cell(status)="data">
                                            <span :class="{
                                                'badge-xs badge-primary-o': data.value === 'active',
                                                'badge-xs badge-secondary-o badge-inactive': data.value === 'inactive'
                                            }">
                                                {{ data.value === 'active' ? 'Actif' : 'Inactif' }}
                                            </span>
                                        </template>


                                        <template #cell(actions)="data">
                                            <div class="dropdown col-lg-12 algn-center">
                                                <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                                    <i class="fa fa-ellipsis-v"></i>
                                                </a>
                                                <ul
                                                    class="dropdown-menu dropdown-menu-right custom-drop animate animate-zoomIn">
                                                    <!-- <li>
                                                        <a href="#" class="text-secondary ml-auto">
                                                            <i class="ic-document-duplicate"></i> &nbsp;
                                                            Dupliquer
                                                        </a>
                                                    </li> -->
                                                    <li>
                                                        <a href="javascript:void(0);" class="text-secondary ml-auto"
                                                            @click="setModelAnalyse(data.item, 'view')" data-toggle="modal"
                                                            data-target=".preview-modal-lg">
                                                            <i class="ic-eye"></i> &nbsp;
                                                            Visualiser
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" class="text-secondary ml-auto"
                                                            @click="editModelAnalyse(data.item)">
                                                            <i class="ic-edit"></i> &nbsp;
                                                            Modifier
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" class="text-secondary ml-auto"
                                                            @click="toggleStatus(data.item)">
                                                            <i
                                                                :class="{ 'ic-minus-circle': data.item.status === 'active', 'ic-check-outline': data.item.status === 'inactive' }"></i>
                                                            &nbsp;
                                                            {{ data.item.status === 'active' ? 'Désactiver' : 'Activer' }}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" class="text-secondary ml-auto"
                                                            @click="setModelAnalyse(data.item, 'delete')">
                                                            <i class="ic-trash-outline"></i> &nbsp;
                                                            Supprimer
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </template>
                                    </b-table>

                                    <b-row class="ml-auto" v-if="modelesAnalyses.length > 0">
                                        <b-pagination v-model="currentPage" :total-rows="modelesAnalyses.length"
                                            :per-page="perPage" aria-controls="my-table" class="ml-auto"></b-pagination>
                                    </b-row>
                                </div>

                                <div v-if="model_is_loading == true" class="pdtb-2 algn-center">
                                    <div  class="spinner-border text-secondary" role="status">
                                        <span class="sr-only ">Loading...</span>
                                    </div> 
                                </div>

                                <div v-if="!model_is_loading && model_is_empty" class="pdtb-2 algn-center">
                                    <div class="no-data">
                                        <i class="fa fa-exclamation"></i>
                                    </div>
                                    <h5 class="text-danger font-22">Aucune donnée disponible</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ConfirmationModal id="delete-confirm-modal" @confirm="confirmDeleteModel">
            <template v-slot:subtitle>Êtes-vous sûre de vouloir supprimer le modèle : </template>
            <strong slot="subtitle2">{{ selectedModelAnalyse?.name }}</strong>
        </ConfirmationModal>

        <PreviewModelFullModalVue :model="selectedModelAnalyse" v-if="selectedModelAnalyse" />
    </section>
</template>

<script>
import $ from "jquery";

import ConfirmationModal from '@/components/dialogs/ConfirmationModal.vue';
import PreviewModelFullModalVue from '../editer/components/PreviewModelFullModal.vue';

import { showToast } from "@/utils/notifications";

export default {
    name: "liste-modeles-analyse",
    components: {
        ConfirmationModal,
        PreviewModelFullModalVue,
    },
    props: [],
    data() {
        return {
            tableColumnNames: [
                { key: "name", label: "Nom du modèle" },
                { key: "analyse.nom", label: "Type d’analyse" },
                { key: "status", label: "Statut" },
                "actions",
            ],
            tableIsBusy: true,
            searchText: "",
            perPage: 10,
            currentPage: 1,
            selectedAnalyse: null,
            selectedModelAnalyse: null,
            model_is_empty: false,
            model_is_loading: true
        };
    },
    computed: {
        analyses() {
            const analyses = this.$store.getters["analyses"];

            const allFilterOption = {
                id: 0,
                nom: "Toutes les analyses",
            }

            return [allFilterOption, ...analyses];
        },

        modelesAnalyses() {
            return this.$store.getters["modeles_analyses"];
        },
    },
    mounted() {
        setTimeout(() => {
            $(".shw").fadeIn();
        }, 500);

        this.$store.dispatch("getAnalyses");

        let params = {
            status: "all",
        }
        this.getListModelAnalyse(params)
    },

    watch: {
        selectedAnalyse() {
            let params = {}

            if (this.selectedAnalyse.id === 0) {
                params = {
                    status: "all",
                }
            } else {
                params = {
                    analyse_id: this.selectedAnalyse.id,
                }
            }

            this.getListModelAnalyse(params)
        },
    },

    methods: {
        getListModelAnalyse(params) {
            this.model_is_loading = true

            this.$store.dispatch("fetchModelesAnalyses", params).then(() => {
                this.model_is_empty = (this.modelesAnalyses.length > 0)?false:true
                this.model_is_loading = false
            });
        },

        setModelAnalyse(model, action) {
            this.selectedModelAnalyse = model;
            if (action === "delete") {
                this.$bvModal.show("delete-confirm-modal");
            } else if (action === "view") {
                $('.preview-modal-lg').modal('show');
            }
        },

        confirmDeleteModel() {
            this.$store.dispatch("deleteModeleAnalyse", this.selectedModelAnalyse.id).then(() => {
                showToast("Le modèle a été supprimé avec succès", "success");
            }).catch(() => {
                showToast("Impossible de supprimer le modèle", "error");
            });
        },

        toggleStatus: function (model) {
            this.$store.dispatch("activateDeactivateModeleAnalyse", { id: model.id })
                .then(() => {
                    showToast("Le statut du modèle a été modifié avec succès", "success");
                }).catch(() => {
                    showToast("Impossible de changer le statut du modèle", "error");
                });
        },

        editModelAnalyse(model) {
            this.$store.dispatch("setModeleAnalyse", model);
            this.$router.push({ name: "creerModifierModeleAnalyse", params: { id: model.id, action: "editer" } });
        },
    },
};
</script>

<style src="./styles.scss" scoped lang="scss"></style>